import request from "@/CommonDP/utils/request";
// 项目
export default {
  publish(params) {
    return request.post("/dyn-version/publish", params);
  },

  queryPublishVersionList() {
    return request.get(`/dyn-version/list`);
  },

  // 导出
  exportFile(version) {
    return request({
      responseType: "blob",
      url: `/dyn-version/export?version=${version}`,
      method: "post",
      data: {}
    });
  },

  updatePublishRemark(params) {
    return request.post("/dyn-version/updatePublishRemark", params);
  }
};
